import React, { useState } from 'react';

import {
  NavLink,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { selectAcquisitionOrderByCampaign } from '../../selectors/acquisitionOrder';
import { useSelector } from 'react-redux';

import Modal from '../../components/Common/Modal/Modal';
import FormLead from '../../components/Leads/FormLead';
import FormSurvey from '../../components/Surveys/FormSurvey';
import ShowNote from '../../components/AcquisitionOrders/ShowNote';
import DataEntryLinkTable from '../../components/MonetizationOrders/DataEntryLinkTable';
import AiConversations from '../../components/Leads/AiConversations';
import FiscalCodeAlert from '../Common/FiscalCodeAlert';
import DealerFinder from '../Common/DealerFinder';
import LocalAgencyFinder from '../Common/LocalAgencyFinder';

import classnames from 'classnames';
import { linkify } from '../../helpers/sharedFunction';
import { useTranslation } from 'react-i18next';

const ManageLead = ({ lead, call, survey, loading }) => {
  const [activeTab, setActiveTab] = useState('1');
  const [toolsDropdownOpen, setToolsDropdownOpen] = useState(false);

  const [fiscalCodeAlert, setFiscalCodeAlert] = useState(false);
  const [dealerModal, setDealerModal] = useState(false);
  const [localAgencyModal, setLocalAgencyModal] = useState(false);

  const [formIsValid, setFormIsValid] = useState('');

  const acquisitionOrder = useSelector(
    selectAcquisitionOrderByCampaign(lead ? lead.campaignId : null),
  );

  let formLeadStatus = null;

  const handleSubmitLeadForm = async () => {
    if (!formLeadStatus) return;

    const { submitForm, resetForm, values, isValid } = formLeadStatus;
    setFormIsValid(isValid);
    if (isValid) {
      submitForm();
      resetForm({ values });
    }
  };

  const toolsDropdownToggle = () => setToolsDropdownOpen(!toolsDropdownOpen);

  const toggleTab = (tab) => activeTab !== tab && setActiveTab(tab);

  const { t } = useTranslation();

  return (
    <>
      <div className="d-flex">
        <Nav pills className="flex-grow-1">
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: activeTab === '1',
              })}
              onClick={() => toggleTab('1')}
            >
              <span className="d-none d-sm-block">Lead</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: activeTab === '2',
              })}
              onClick={() => toggleTab('2')}
            >
              <span className="d-none d-sm-block">{t('Survey')}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: activeTab === '3',
              })}
              onClick={() => toggleTab('3')}
            >
              <span className="d-none d-sm-block">Link</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: activeTab === '4',
              })}
              onClick={() => toggleTab('4')}
            >
              <span className="d-none d-sm-block">Info</span>
            </NavLink>
          </NavItem>
          {lead.note && (
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === '5',
                })}
                onClick={() => toggleTab('5')}
              >
                <span className="d-none d-sm-block">Note</span>
              </NavLink>
            </NavItem>
          )}
          {lead.aiConversationId && (
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === '6',
                })}
                onClick={() => toggleTab('6')}
              >
                <span className="d-none d-sm-block">
                  {t('AI Agent')}
                  {/*
                    The mark, and it says more than "there is a tab": it
                    appears only when the agent handed THIS call over, which
                    is the case where the operator has to read the
                    conversation before picking up the phone. Until now
                    nothing on this page said so — aiHandoffReason was
                    written on the call and rendered nowhere.
                  */}
                  {!!call?.aiHandoffReason && (
                    <Badge color="danger" pill className="ml-1">
                      <i className="bx bx-bot align-middle font-size-14"></i>
                    </Badge>
                  )}
                </span>
              </NavLink>
            </NavItem>
          )}
          <Dropdown nav isOpen={toolsDropdownOpen} toggle={toolsDropdownToggle}>
            <DropdownToggle nav caret custom-ignore={'true'}>
              {t('Tools') + ' '}
              <i className="mdi mdi-chevron-down"></i>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => setFiscalCodeAlert(true)}>
                {t('Fiscal Code')}
              </DropdownItem>
              {typeof lead?.carBrandId === 'number' && (
                <DropdownItem onClick={() => setDealerModal(true)}>
                  {t('Dealer Finder')}
                </DropdownItem>
              )}
              {acquisitionOrder?.localAgencyFinderId && (
                <DropdownItem onClick={() => setLocalAgencyModal(true)}>
                  {t('Local Agency Finder')}
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>

          {lead?.carBrand && lead?.carModel && (
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  window.open(
                    `https://www.google.com/search?q=${lead?.carBrand} ${lead?.carModel} info + foto`,
                    '_blank',
                  );
                }}
              >
                <span className="d-none d-sm-block">
                  {t('Search on Google')}
                </span>
              </NavLink>
            </NavItem>
          )}
          {lead?.zipCode && (
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  window.open(
                    `https://www.nonsolocap.it/cap?k=${lead?.zipCode}`,
                    '_blank',
                  );
                }}
              >
                <span className="d-none d-sm-block">{t('NonSoloCap')}</span>
              </NavLink>
            </NavItem>
          )}
        </Nav>
        {activeTab === '1' && (
          <Nav className="navbar-right">
            {formIsValid !== '' && (
              <NavItem className="font-size-24 mr-2">
                <i
                  className={`bx ${
                    formIsValid
                      ? 'bx-check-circle text-success'
                      : 'bx-error text-danger'
                  }`}
                ></i>
              </NavItem>
            )}
            <NavItem>
              <button
                type="button"
                disabled={loading}
                className="btn btn-dark waves-effect waves-light"
                onClick={handleSubmitLeadForm}
              >
                <i className="bx bx-pencil font-size-16 align-middle mr-2"></i>
                {t('Save')}
              </button>
            </NavItem>
          </Nav>
        )}
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <FormLead
            create={!lead}
            loading={loading}
            lead={lead}
            disabledSelectCampaign
            hideCampaignField
            hideClosureFields
            hideSubmitButton
            manageDirtyForm
            bindSubmitForm={(formStatus) => {
              formLeadStatus = formStatus;
            }}
          />
        </TabPane>
        <TabPane tabId="2">
          {survey ? (
            <FormSurvey create={!survey} survey={survey} loading={loading} />
          ) : (
            <Card>
              <CardBody>
                <h5 className="mt-4 ml-4">
                  {t('This user did not answer the survey')}.
                </h5>
              </CardBody>
            </Card>
          )}
        </TabPane>
        <TabPane tabId="3">
          <Card>
            <CardBody>
              <DataEntryLinkTable
                lead={lead}
                acquisitionOrder={acquisitionOrder}
              />
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="4">
          {acquisitionOrder && acquisitionOrder.note ? (
            <ShowNote acquisitionOrder={acquisitionOrder} />
          ) : (
            <Card>
              <CardBody>
                <h5 className="mt-4 ml-4">
                  {t('There is no information about this acquisition order')}.
                </h5>
              </CardBody>
            </Card>
          )}
        </TabPane>
        {lead.note && (
          <TabPane tabId="5">
            <Card>
              <CardBody>
                <p
                  style={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: '3',
                    fontSize: '14px',
                  }}
                  dangerouslySetInnerHTML={{ __html: linkify(lead.note) }}
                />
              </CardBody>
            </Card>
          </TabPane>
        )}
        {lead.aiConversationId && (
          <TabPane tabId="6">
            {/*
              Mounted only while the tab is open, unlike every other pane
              here: AiConversations fetches the lead's conversations and the
              selected one's messages on mount, and TabContent keeps all
              panes in the DOM. Rendered eagerly it would be two reads on
              every call an operator opens, read or not, on the busiest page
              in the CRM. The other panes are free because they read what the
              store already holds.
            */}
            {activeTab === '6' && <AiConversations lead={lead} />}
          </TabPane>
        )}
      </TabContent>
      <FiscalCodeAlert
        isOpen={fiscalCodeAlert}
        onConfirm={() => setFiscalCodeAlert(false)}
        lead={lead}
      />
      <Modal
        size="lg"
        title={`${lead?.carBrand} ${t('Dealer Finder')}`}
        isOpen={dealerModal}
        toggle={() => setDealerModal(!dealerModal)}
        unmountOnClose={false}
        showClose
        scrollable
      >
        <DealerFinder lead={lead} />
      </Modal>
      <Modal
        size="lg"
        title={`${t('Local Agency Finder')}`}
        isOpen={localAgencyModal}
        toggle={() => setLocalAgencyModal(!localAgencyModal)}
        unmountOnClose={false}
        showClose
        scrollable
      >
        <LocalAgencyFinder lead={lead} acquisitionOrder={acquisitionOrder} />
      </Modal>
    </>
  );
};

export default ManageLead;
